import { ObservableArray, View } from "binder"
import { MessageBoxViewModel, singleButton } from "./messageBox-viewModel"

export class MessageBoxView extends View<MessageBoxViewModel>{
    GetViewUniqueId(): string {
        return "V-72EA2AD5-9027-456E-BDA1-B305CFFE23B8"
    }
    loadHtml(): string {
        let element = require('./messageBox.html').default;
        let style = require('./messageBox.less');
        return element;
    }
    constructor() {
       super();
    }

    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
    public set messsage(v: string) { this._messsage = v; } public get messsage(): string { return this._messsage;} private _messsage: string;
    public set type(v: string) { this._type = v; } public get type(): string { return this._type;} private _type: string;
    public set buttons(v: ObservableArray<singleButton>) { this._buttons = v; } public get buttons(): ObservableArray<singleButton> { return this._buttons;} private _buttons: ObservableArray<singleButton>;
    public set isDanger(v: boolean) { this._isDanger = v; } public get isDanger(): boolean { return this._isDanger;} private _isDanger: boolean;
    public set isSuccess(v: boolean) { this._isSuccess = v; } public get isSuccess(): boolean { return this._isSuccess;} private _isSuccess: boolean;
    public set isWarning(v: boolean) { this._isWarning = v; } public get isWarning(): boolean { return this._isWarning;} private _isWarning: boolean;
    public set isDark(v: boolean) { this._isDark = v; } public get isDark(): boolean { return this._isDark;} private _isDark: boolean;
    
}
